/* Lookbook lightbox: tap a look -> full-screen image + "Shop the Look" (its tagged products). */
(function () {
  function initSection(section) {
    if (section.__lookbookInit) return;
    section.__lookbookInit = true;

    var tiles = Array.prototype.slice.call(section.querySelectorAll("[data-lookbook-open]"));
    var lb = section.querySelector("[data-lookbook-lightbox]");
    if (!tiles.length || !lb) return;

    var imgEl = lb.querySelector("[data-lb-img]");
    var shopEl = lb.querySelector("[data-lb-shop]");
    var shopListEl = lb.querySelector("[data-lb-shop-list]");
    var current = -1;

    var looks = tiles.map(function (t) {
      var source = t.parentElement.querySelector(".lookbook__products-source");
      return {
        full: t.getAttribute("data-full"),
        shopHTML: source ? source.innerHTML.trim() : "",
      };
    });

    function render(i) {
      var look = looks[i];
      if (!look) return;
      current = i;
      imgEl.src = look.full;
      if (look.shopHTML) {
        shopListEl.innerHTML = look.shopHTML;
        shopEl.hidden = false;
      } else {
        shopListEl.innerHTML = "";
        shopEl.hidden = true;
      }
    }

    function open(i) {
      render(i);
      lb.classList.add("is-open");
      lb.setAttribute("aria-hidden", "false");
      document.body.classList.add("lookbook-lightbox-open");
    }
    function close() {
      lb.classList.remove("is-open");
      lb.setAttribute("aria-hidden", "true");
      document.body.classList.remove("lookbook-lightbox-open");
      if (current > -1 && tiles[current]) tiles[current].focus();
    }
    function step(dir) {
      if (current < 0) return;
      render((current + dir + looks.length) % looks.length);
    }

    tiles.forEach(function (t, i) {
      t.addEventListener("click", function () { open(i); });
    });
    lb.querySelectorAll("[data-lb-close]").forEach(function (b) {
      b.addEventListener("click", close);
    });
    var prev = lb.querySelector("[data-lb-prev]");
    var next = lb.querySelector("[data-lb-next]");
    if (prev) prev.addEventListener("click", function () { step(-1); });
    if (next) next.addEventListener("click", function () { step(1); });

    document.addEventListener("keydown", function (e) {
      if (!lb.classList.contains("is-open")) return;
      if (e.key === "Escape") close();
      else if (e.key === "ArrowLeft") step(-1);
      else if (e.key === "ArrowRight") step(1);
    });

    // Touch swipe on the image
    var startX = 0;
    var fig = lb.querySelector(".lookbook__lb-figure");
    if (fig) {
      fig.addEventListener("touchstart", function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
      fig.addEventListener("touchend", function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
  }

  function init() {
    document.querySelectorAll("[data-lookbook]").forEach(initSection);
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
